import * as types from './action-types';
import { InvoiceService, PaymentRequestService } from 'frilans-finans';
import axios from 'axios';

export const setStatus = (status) => {
  return {
    type: types.SET_STATUS,
    payload: status
  };
};

export const fetchInvoice = (uuid, includes) => {
  return (dispatch) => {
    dispatch({type: types.FETCH_INVOICE});
    return InvoiceService.getByUuid(uuid, includes)
      .then((invoice) => {
        dispatch({type: types.SET_INVOICE, payload: invoice});
        return invoice;
      }, (error) => {
        dispatch({type: types.ERROR_INVOICE, payload: error});
      });
  };
};

export const createPaymentRequest = (uuid) => {
  return (dispatch) => {
    dispatch({type: types.CREATE_PAYMENT_REQUEST});

    return PaymentRequestService.create(uuid)
      .then((paymentRequest) => {
        dispatch({type: types.SET_PAYMENT_REQUEST, payload: paymentRequest});
      }, (error) => {
        dispatch({type: types.ERROR_PAYMENT_REQUEST, payload: error});
      });
  };
};

export const createInvoiceEmail = (email) => {
  return (dispatch, getState) => {
    dispatch({type: types.CREATING_INVOICE_EMAIL});
    const { payment } = getState();
    const uuid = payment.invoice.data.uuid;

    return axios.post(`backend://invoices/uuid/${uuid}/email`, {data: {attributes: {email: email}}})
      .then((response) => {
        dispatch({type: types.SUCCESS_INVOICE_EMAIL});
      }, (error) => {
        dispatch({type: types.ERROR_INVOICE_EMAIL, payload: error});
      });
  };
};

export const getLatestPaymentRequest = (email) => {
  return (dispatch, getState) => {
    // dispatch({type: types.CREATING_INVOICE_EMAIL});
    const { payment } = getState();
    const uuid = payment.invoice.data.uuid;

    return axios.get(`backend://payment-request/${uuid}`)
      .then((response) => {
        dispatch({type: types.SET_PAYMENT_REQUEST, payload: response.data.data.attributes});
      }, (error) => {
        dispatch({type: types.ERROR_PAYMENT_REQUEST, payload: error});
      });
  };
};



/** WEBPACK FOOTER **
 ** ./src/redux/modules/payment/index.js
 **/